import { render, staticRenderFns } from "./security_document_requests.vue?vue&type=template&id=2b2bbba2&scoped=true"
import script from "./security_document_requests.vue?vue&type=script&lang=js"
export * from "./security_document_requests.vue?vue&type=script&lang=js"
import style0 from "./security_document_requests.vue?vue&type=style&index=0&id=2b2bbba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2bbba2",
  null
  
)

export default component.exports